import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "check-circle-fill" }, [
      _createElementVNode("path", {
        id: "Subtract",
        d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM10.5265 4.34846C10.2702 4.09218 9.85474 4.09218 9.59845 4.34846C9.59227 4.35465 9.58645 4.36121 9.58105 4.36809L6.54272 8.23965L4.71089 6.40782C4.45461 6.15154 4.0391 6.15154 3.78281 6.40782C3.52653 6.6641 3.52653 7.07962 3.78281 7.3359L6.09846 9.65154C6.35474 9.90782 6.77025 9.90782 7.02653 9.65154C7.03224 9.64583 7.03763 9.63981 7.04267 9.63351L10.5358 5.26704C10.7828 5.01009 10.7797 4.6016 10.5265 4.34846Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }